import React, { Component } from "react";
import { createBrowserHistory } from "history";
import { Route, Switch, Redirect, HashRouter } from "react-router-dom";
import { PrivateRoute } from "./Helper/PrivateRoute";
import Login from "components/Login/LoginNew.jsx";
import Register from "components/Register/Register.jsx";
import Pricing from "components/Pricing/Pricing.jsx";
import ForgotPassword from "components/ForgotPassword/ForgetPasswordNew.jsx";
import ForgotUserName from "components/ForgotPassword/ForgetUserName.jsx";
import ResetPassword from "components/ResetPassword/ResetPassword.jsx";
import Dashboard from "components/Dashboard/Dashboard.jsx";
import TransactionList from "components/Transactions/List/TransactionList.jsx";
import TransactionListNew from "components/Transactions/List/TransactionListNew.jsx";
import TransactionsCreate from "components/Transactions/Create/Create.jsx";
import TransactionsDetail from "components/Transactions/Detail/Detail.jsx";
import CalendarModule from "components/Calendar/Calendar.jsx";
import Contacts from "./components/Contacts/Contacts.jsx";
import ContactOld from "./components/Contacts/ContactOld.jsx";
import Documents from "components/Documents/Documents.jsx";
import RegistrationRequests from "components/RegistrationRequests/RegistrationRequests.jsx";
import PendingProfiles from "components/RegistrationRequests/PendingProfiles.jsx";
import BuyerAgent from "components/BuyerAgent/BuyerAgent.jsx";
import Vendor from "components/Vendors/Vendors.jsx";
import Buyers from "components/HomeBuyers/HomeBuyers.jsx";
import BuyerAgentCreate from "components/BuyerAgent/InviteAgent.jsx";
import UserProfile from "components/UserProfile/UserProfile.jsx";
import ChangePassword from "components/UserProfile/changePasswordNew.jsx";
import MasterTemplate from "components/MasterTemplate/MasterTemplate.jsx";
import BuyerAgentMasterTemplate from "components/MasterTemplate/BuyerAgentMasterTemplate.jsx";
import ThankYou from "components/ThankYou/ThankYou.jsx";
import AccessDenied from "components/ErrorPage/AccessDenied.jsx";
import AdminUsers from "components/AdminUsers/AdminUsers.jsx";
import EmailTemplates from "components/EmailTemplates/EmailTemplates.jsx";
import Details from "components/EmailTemplates/Details.jsx";
import SystemNotifications from "components/SystemNotifications/SystemNotifications.jsx";
import Notification from "components/Notification/Notification.jsx";
import NotificationSetting from "components/Notification/NotificationSetting.jsx";
import ManageData from "./components/ManageData/ManageData";
import Contingencies from "./components/Contingencies/Contingencies";
import Roles from "./components/Roles/Roles";
import AllTaskList from "components/Dashboard/AllTaskList.jsx";
import CounterReport from "components/Report/CounterReport.jsx";
import SubscriptionList from "components/Subscription/SubscriptionList.jsx";
import AddSubscription from "components/Subscription/AddSubscription/AddSubscription.jsx";
import EditSubscription from "components/Subscription/AddSubscription/EditSubscription.jsx";
import SubscriptionDetail from "components/Subscription/SubscriptionDetail.jsx";
import ManagePayment from "components/Subscription/ManagePayment/ManagePayment.jsx";
import ChangePlan from "components/Subscription/ChangePlan/ChangePlan.jsx";
import ActivatePlan from "components/Subscription/ChangePlan/ActivatePlan.jsx";
import PlanSetting from "components/PlanSetting/PlanSetting.jsx";
import HearAboutUs from "components/HearAboutUs/HearAboutUs";
import TransactionType from "./components/TransactionType/TransactionType";
import Clients from "./components/Clients/Clients";
import ClientsOld from "./components/Clients/ClientsOld";
import ExistingTransaction from "./components/Transactions/Create/ExistingTransaction";
import FinanceReports from "./components/FinanceReports/FinanceReports";
import PublicForms from "./components/PublicForms/PublicForms";
import IntakeForm from "./components/Forms/Intake";
import ConsentForm from "./components/Forms/Consent";
import ClientSummary from "./components/Forms/ClientSummary";
import AfterCare from "./components/Forms/AfterCare";
import FormReceived from "./components/PublicForms/FormReceived";
import AcctownerSettings from "./components/AcctownerSettings/AcctownerSettings";
import RegisterNew from "./components/ResetPassword/RegisterNew.jsx";
import BillingItems from "components/BillingModule/BillingItem/BillingItems.jsx";
import BillingPlansList from "components/BillingModule/BillingPlans/BillingPlansList.jsx";
import BillingPlanForm from "components/BillingModule/BillingPlans/BillingPlanForm.jsx";
import EditbillingPlan from "./components/BillingModule/BillingPlans/EditbillingPlan";
import BillingPaymentDetails from "components/BillingModule/BillingPayment/BillingPaymentDetails.jsx";
import UserBillingPlanDetails from "./components/BillingModule/BillingPlans/UserBillingPlanDetails";
import BillingPaymentMethodsList from "./components/BillingModule/BillingPayment/ManagePaymentMethods/BillingPaymentMethodsList";
import BillingHistory from "./components/BillingModule/BillingHistory/BillingHistory";
import ContactsPermissions from "./components/ContactsPermissions/ContactsPermissionsListing";
import TaskCalendarModule from "components/Calendar/TaskCalendar.jsx";
import TimezoneTest from "./components/timezonetest/TimezoneTest";
import ChangeComapny from "./components/ChangeCompany/ChangeCompany";
import QuickAppointment from "components/QuickAppointment/QuickAppointment.jsx";
import PathwayMasterTemplate from "components/Pathway/PathwayMasterTemplate.jsx";
import AdminPathwayMasterTemplate from "components/Pathway/AdminPathwayMasterTemplate.jsx";
import RegisterAccountowner from "./components/Register/AccownerRegistration/registerAccountowner";
import AiImagegenration from "./components/TellagentAi/AiImagegenration.jsx";
import Aiimagevariations from "./components/TellagentAi/Aiimagevariations.jsx";
import Aiversions from "./components/TellagentAi/Aiversions.jsx";
import EditImageai from "./components/TellagentAi/EditImageai.jsx";
import AiImageMainPage from "./components/TellagentAi/AiImageMainPage.jsx";
import AppointmentsCalendarModule from "components/AppointmentsCalendar/AppointmentsCalendar.jsx";
import OpneaiVersion from "./components/OpenaiVersionControl/OpneaiVersion.jsx";
import AssignVersions from "./components/OpenaiVersionControl/AssignVersions.jsx";
import SystemBannersList from "./components/SystemBanners/SystemBannersList.jsx";
import SystemBannerForm from "./components/SystemBanners/SystemBannerForm.jsx";
import SystemVersionsList from "./components/SystemVersion/SystemVersionList.jsx";
import SystemVersionForm from "./components/SystemVersion/SystemVersionForm.jsx";
import UserPersonalDocuments from "./components/UserPersonalDocuments/Documents.jsx";
import CheckInForm from "./components/Forms/CheckIn.jsx";
import ShopsListing from "./components/Shops/ShopsListing.jsx";
import ShopDetails from "./components/Shops/ShopDetails.jsx";
import BookAppointment from "./components/Shops/BookAppointment.jsx";
import AiPromptsListing from "./components/TellagentAi/AiPromptsListing.jsx";
import AiCatSubCategoryList from "./components/TellagentAi/AiCatSubCategoryList.jsx";
import Aiprompt from "./components/TellagentAi/Aiprompt";
import Settings from "./components/Settings/Settings.jsx";
import Lookupdata from "./components/LookUpdata/Lookupdata.jsx";
const hist = createBrowserHistory();

class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      miniActive: "",
      sidebar: "",
    };
  }

  render() {
    return (
      <HashRouter history={hist}>
        <Switch>
          <PrivateRoute
            permissionType={["DASHBOARD_VIEWER"]}
            exact
            path="/dashboard"
            miniActive={this.state.miniActive}
            component={Dashboard}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE", "TRANSACTION_CREATOR"]}
            exact
            path="/financereports"
            miniActive={this.state.miniActive}
            component={FinanceReports}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE", "TRANSACTION_VIEWER"]}
            exact
            path="/transactions-old"
            miniActive={this.state.miniActive}
            component={TransactionList}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE", "TRANSACTION_VIEWER"]}
            exact
            path="/artwork"
            miniActive={this.state.miniActive}
            component={TransactionListNew}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "TRANSACTION_CREATOR",
              "manage_transactions",
            ]}
            exact
            path="/artwork/create"
            miniActive={this.state.miniActive}
            component={TransactionsCreate}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE", "manage_appointments"]}
            exact
            path="/artwork/addappointment"
            miniActive={this.state.miniActive}
            component={ExistingTransaction}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "TRANSACTION_VIEWER",
              "TRANSACTION_EDITOR",
            ]}
            exact
            path="/artwork/detail/:transId"
            miniActive={this.state.miniActive}
            component={TransactionsDetail}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "TRANSACTION_VIEWER",
              "TRANSACTION_EDITOR",
            ]}
            exact
            path="/artwork/detail-new/:transId"
            miniActive={this.state.miniActive}
            component={TransactionsDetail}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "TRANSACTION_VIEWER",
              "TRANSACTION_EDITOR",
            ]}
            exact
            path="/intake"
            miniActive={this.state.miniActive}
            component={IntakeForm}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "TRANSACTION_VIEWER",
              "TRANSACTION_EDITOR",
            ]}
            exact
            path="/consent"
            miniActive={this.state.miniActive}
            component={ConsentForm}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/settings"
            miniActive={this.state.miniActive}
            component={Settings}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          {/* <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/AiVersions"
            miniActive={this.state.miniActive}
            component={Aiversions}
            onUpdate={(miniActive) => this.setState({ miniActive: miniActive })}
          /> */}
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/BillingModule/BillingItems"
            miniActive={this.state.miniActive}
            component={BillingItems}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              // "ADMIN_VIEWABLE",
              // "TRANSACTION_CREATOR",
              "aiimagetool",
              "manage_image_ai",
            ]}
            exact
            path="/generateImage"
            miniActive={this.state.miniActive}
            component={AiImageMainPage}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[]}
            exact
            path="/generateImage-AccessDenied"
            miniActive={this.state.miniActive}
            component={AccessDenied}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          {/* <PrivateRoute
            permissionType={["ADMIN_VIEWABLE", "TRANSACTION_CREATOR"]}
            exact
            path="/imageVariation"
            miniActive={this.state.miniActive}
            component={Aiimagevariations}
            onUpdate={(miniActive) => this.setState({ miniActive: miniActive })}
          /> */}
          {/* <PrivateRoute
            permissionType={["ADMIN_VIEWABLE", "TRANSACTION_CREATOR"]}
            exact
            path="/editImageAi"
            miniActive={this.state.miniActive}
            component={EditImageai}
            onUpdate={(miniActive) => this.setState({ miniActive: miniActive })}
          /> */}
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/BillingModule/BillingPlansList"
            miniActive={this.state.miniActive}
            component={BillingPlansList}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/lookupmasterdata"
            miniActive={this.state.miniActive}
            component={Lookupdata}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/BillingModule/BillingPlans"
            miniActive={this.state.miniActive}
            component={BillingPlanForm}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/BillingModule/EditbillingPlan"
            miniActive={this.state.miniActive}
            component={EditbillingPlan}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/BillingModule/BillingHistory"
            miniActive={this.state.miniActive}
            component={BillingHistory}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "view_billing_details",
              "manage_billing_details",
            ]}
            exact
            path="/BillingModule/BillingPaymentDetails"
            miniActive={this.state.miniActive}
            component={BillingPaymentDetails}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["view_plan_details"]}
            exact
            path="/BillingModule/UserBillingPlanDetails"
            miniActive={this.state.miniActive}
            component={UserBillingPlanDetails}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "view_payment_method",
              "manage_payment_method",
            ]}
            exact
            path="/BillingModule/BillingPaymentMethods"
            miniActive={this.state.miniActive}
            component={BillingPaymentMethodsList}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "TRANSACTION_VIEWER",
              "TRANSACTION_EDITOR",
            ]}
            exact
            path="/clientSummary"
            miniActive={this.state.miniActive}
            component={ClientSummary}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "TRANSACTION_VIEWER",
              "TRANSACTION_EDITOR",
            ]}
            exact
            path="/aftercare"
            miniActive={this.state.miniActive}
            component={AfterCare}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          {/* <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "CALENDAR_MANAGER",
              "view_calendar",
            ]}
            exact
            path="/taskCalendar"
            miniActive={this.state.miniActive}
            component={TaskCalendarModule}
            onUpdate={(miniActive) => this.setState({ miniActive: miniActive })}
          /> */}
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "APPONTMENTS_MANAGER",
              "view_appointments",
              "manage_appointments",
            ]}
            exact
            path="/calendar"
            miniActive={this.state.miniActive}
            component={CalendarModule}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE", "CALENDAR_MANAGER"]}
            exact
            path="/calendar/:date"
            miniActive={this.state.miniActive}
            component={CalendarModule}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "CONTACT_VIEWER",
              "CONTACT_EDITOR",
              "manage_contact",
              "view_contact",
            ]}
            exact
            path="/contacts"
            miniActive={this.state.miniActive}
            component={Contacts}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "CONTACT_VIEWER",
              "CONTACT_EDITOR",
              "view_permission_contact",
              "manage_permission_contact",
            ]}
            exact
            path="/contactsPermissions"
            miniActive={this.state.miniActive}
            component={ContactsPermissions}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "CONTACT_VIEWER",
              "CONTACT_EDITOR",
            ]}
            exact
            path="/contacts-old"
            miniActive={this.state.miniActive}
            component={ContactOld}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "CLIENT_VIEWER",
              "CLIENT_EDITOR",
            ]}
            exact
            path="/clients-old"
            miniActive={this.state.miniActive}
            component={ClientsOld}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "CLIENT_VIEWER",
              "CLIENT_EDITOR",
              "manage_client",
              "view_client",
            ]}
            exact
            path="/clients"
            miniActive={this.state.miniActive}
            component={Clients}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE", "DOCUMENT_VIEWER"]}
            exact
            path="/documents"
            miniActive={this.state.miniActive}
            component={Documents}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/RegistrationRequests"
            miniActive={this.state.miniActive}
            component={RegistrationRequests}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/PendingProfiles"
            miniActive={this.state.miniActive}
            component={PendingProfiles}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/AccountOwner"
            miniActive={this.state.miniActive}
            component={BuyerAgent}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/Vendors"
            miniActive={this.state.miniActive}
            component={Vendor}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/Buyers"
            miniActive={this.state.miniActive}
            component={Buyers}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/AccountOwner/create"
            miniActive={this.state.miniActive}
            component={BuyerAgentCreate}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          {/* <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/systemnotifications"
            miniActive={this.state.miniActive}
            component={SystemNotifications}
            onUpdate={(miniActive) => this.setState({ miniActive: miniActive })}
          /> */}
          {/* <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/Report"
            miniActive={this.state.miniActive}
            component={CounterReport}
            onUpdate={(miniActive) => this.setState({ miniActive: miniActive })}
          /> */}
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/Subscription"
            miniActive={this.state.miniActive}
            component={SubscriptionList}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/Subscription/AddSubscription"
            miniActive={this.state.miniActive}
            component={AddSubscription}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/Subscription/EditSubscription"
            miniActive={this.state.miniActive}
            component={EditSubscription}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          {/* <PrivateRoute
            permissionType={["PROFILE_MANAGER"]}
            exact
            path="/Subscription/SubscriptionDetail"
            miniActive={this.state.miniActive}
            component={SubscriptionDetail}
            onUpdate={(miniActive) => this.setState({ miniActive: miniActive })}
          /> */}
          {/* <PrivateRoute
            permissionType={["PROFILE_MANAGER"]}
            exact
            path="/Subscription/ManagePayment"
            miniActive={this.state.miniActive}
            component={ManagePayment}
            onUpdate={(miniActive) => this.setState({ miniActive: miniActive })}
          /> */}
          {/* <PrivateRoute
            permissionType={["PROFILE_MANAGER"]}
            exact
            path="/Subscription/ChangePlan"
            miniActive={this.state.miniActive}
            component={ChangePlan}
            onUpdate={(miniActive) => this.setState({ miniActive: miniActive })}
          /> */}
          {/* <PrivateRoute
            permissionType={["PROFILE_MANAGER"]}
            exact
            path="/Subscription/ActivatePlan"
            miniActive={this.state.miniActive}
            component={ActivatePlan}
            onUpdate={(miniActive) => this.setState({ miniActive: miniActive })}
          /> */}
          <PrivateRoute
            permissionType={["PROFILE_MANAGER", "ADMIN_VIEWABLE"]}
            exact
            path="/UserProfile"
            miniActive={this.state.miniActive}
            component={UserProfile}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["PROFILE_MANAGER", "ADMIN_VIEWABLE"]}
            exact
            path="/UserProfile/:id"
            onEnter={this.requireAuth}
            miniActive={this.state.miniActive}
            component={UserProfile}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["PROFILE_MANAGER", "ADMIN_VIEWABLE"]}
            exact
            path="/changePassword"
            miniActive={this.state.miniActive}
            component={ChangePassword}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "CAMPAIGN_MANAGER",
              "view_master_campaign",
              "manage_master_campaign",
            ]}
            exact
            path="/MasterCampaign"
            miniActive={this.state.miniActive}
            component={BuyerAgentMasterTemplate}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/MasterTemplate"
            miniActive={this.state.miniActive}
            component={MasterTemplate}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/AdminUsers"
            miniActive={this.state.miniActive}
            component={AdminUsers}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/ManageData"
            miniActive={this.state.miniActive}
            component={ManageData}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/contingencies"
            miniActive={this.state.miniActive}
            component={Contingencies}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/roles"
            miniActive={this.state.miniActive}
            component={Roles}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/hearAboutUs"
            miniActive={this.state.miniActive}
            component={HearAboutUs}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/transactionType"
            miniActive={this.state.miniActive}
            component={TransactionType}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/emails"
            miniActive={this.state.miniActive}
            component={EmailTemplates}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/emails/:id"
            miniActive={this.state.miniActive}
            component={Details}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            exact
            path="/AccessDenied"
            miniActive={this.state.miniActive}
            component={AccessDenied}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE", "PROFILE_MANAGER"]}
            exact
            path="/notification"
            miniActive={this.state.miniActive}
            component={Notification}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          {/* <PrivateRoute
            permissionType={["ADMIN_VIEWABLE", "PROFILE_MANAGER"]}
            exact
            path="/notificationsetting"
            miniActive={this.state.miniActive}
            component={NotificationSetting}
            onUpdate={(miniActive) => this.setState({ miniActive: miniActive })}
          /> */}
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/plansetting"
            miniActive={this.state.miniActive}
            component={PlanSetting}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "TRANSACTION_VIEWER",
              "TRANSACTION_EDITOR",
              "TRANSACTION_CREATOR",
            ]}
            exact
            path="/AllTaskList"
            miniActive={this.state.miniActive}
            component={AllTaskList}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["PROFILE_MANAGER"]}
            exact
            path="/settings"
            miniActive={this.state.miniActive}
            component={AcctownerSettings}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["change_company"]}
            exact
            path="/changeCompany"
            component={ChangeComapny}
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "QUICK_APPONTMENT_MANAGER",
              "manage_quick_appointment",
            ]}
            exact
            path="/quickAppointment"
            miniActive={this.state.miniActive}
            component={QuickAppointment}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "CAMPAIGN_MANAGER",
              "view_pathway",
              "manage_pathway",
            ]}
            exact
            path="/pathway"
            miniActive={this.state.miniActive}
            component={PathwayMasterTemplate}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/AdminPathway"
            miniActive={this.state.miniActive}
            component={AdminPathwayMasterTemplate}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "APPONTMENTS_MANAGER",
              "view_appointments",
              "manage_appointments",
            ]}
            exact
            path="/appointmentsCalendar"
            miniActive={this.state.miniActive}
            component={AppointmentsCalendarModule}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/AiVersions"
            miniActive={this.state.miniActive}
            component={OpneaiVersion}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/AssignVersion"
            miniActive={this.state.miniActive}
            component={AssignVersions}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/systemBanners"
            miniActive={this.state.miniActive}
            component={SystemBannersList}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/systemVersionsForm"
            miniActive={this.state.miniActive}
            component={SystemVersionForm}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/systemVersions"
            miniActive={this.state.miniActive}
            component={SystemVersionsList}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/systemBannersForm"
            miniActive={this.state.miniActive}
            component={SystemBannerForm}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["PROFILE_MANAGER", "ADMIN_VIEWABLE"]}
            exact
            path="/uploadPersonalDocuments"
            miniActive={this.state.miniActive}
            component={UserPersonalDocuments}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={[
              "ADMIN_VIEWABLE",
              "TRANSACTION_VIEWER",
              "TRANSACTION_EDITOR",
            ]}
            exact
            path="/checkin"
            miniActive={this.state.miniActive}
            component={CheckInForm}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/AiPromptsListing"
            miniActive={this.state.miniActive}
            component={AiPromptsListing}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/AiPrompt"
            miniActive={this.state.miniActive}
            component={Aiprompt}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <PrivateRoute
            permissionType={["ADMIN_VIEWABLE"]}
            exact
            path="/AiCategorySubCategoryList"
            miniActive={this.state.miniActive}
            component={AiCatSubCategoryList}
            onUpdate={(miniActive) =>
              this.setState({ miniActive: miniActive })
            }
          />
          <Route path="/ThankYou" component={ThankYou} />
          <Route path="/login" component={Login} />
          <Route path="/register/:token?" component={Register} />
          <Route path="/studios/:name" component={ShopDetails} />
          <Route path="/studios" component={ShopsListing} />
          <Route path="/studioDetails" component={ShopDetails} />
          <Route path="/artists/:name" component={BookAppointment} />
          <Route path="/artistDetails" component={BookAppointment} />
          <Route path="/pricing" component={Pricing} />
          <Route path="/forgotpassword" component={ForgotPassword} />
          <Route path="/forgotuserName" component={ForgotUserName} />
          <Route path="/resetpassword/:token?" component={ResetPassword} />
          <Route path="/publicforms/:id?/:token?" component={PublicForms} />
          <Route path="/timezones" component={TimezoneTest} />
          <Route path="/registerContact/:id" component={RegisterNew} />
          <Route path={"/formreceived"} component={FormReceived} />
          <Route
            path="/registerAccountowner/:id"
            component={RegisterAccountowner}
          />
          : <Redirect to={{ pathname: "/login" }} />
        </Switch>
      </HashRouter>
    );
  }
}

export default Routes;
